import { Button } from 'takeat-design-system-ui-kit';
import {
    BodyModal,
    ContainerModal,
    FooterModal,
    HeaderModal,
    Overlay,
    TextBody,
    TextHeader,
} from './styles';
import React, { useState, useEffect, useMemo } from 'react';
import { useAuth } from '~/context/AuthContext';
import { useOrder } from 'context/orderContext';

export const ModalDeliveryBaskets = () => {
    const { user } = useAuth();
    const { pendingBaskets, ongoingBaskets, acceptedBaskets, readyBaskets } = useOrder();

    const [isOpen, setIsOpen] = useState(false);

    // Combina todas as baskets
    const allBaskets = useMemo(() => {
        return [
            ...(pendingBaskets || []),
            ...(ongoingBaskets || []),
            ...(acceptedBaskets || []),
            ...(readyBaskets || [])
        ];
    }, [pendingBaskets, ongoingBaskets, acceptedBaskets, readyBaskets]);

    // Verifica se alguma basket está aberta há mais de 24 horas
    const hasOldBaskets = useMemo(() => {
        const now = new Date();
        const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);

        return allBaskets.filter(session => !session.scheduled_to).some(item => {
            if (!item.basket.start_time) return false;

            const startTime = new Date(item.basket.start_time);
            return startTime < twentyFourHoursAgo;
        });
    }, [allBaskets]);

    useEffect(() => {
        if (!hasOldBaskets) {
            return;
        }

        const today = new Date().toISOString().slice(0, 10);
        const lastShown = localStorage.getItem('@gddashboard:lastShownOldBaskets');

        if (!lastShown || lastShown !== today) {
            setIsOpen(true);
            localStorage.setItem('@gddashboard:lastShownOldBaskets', today);
        }
    }, [hasOldBaskets]);

    const closeModal = () => {
        setIsOpen(false);
    };

    return (
        isOpen && (
            <Overlay>
                <ContainerModal>
                    <HeaderModal>
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <path d="M3.48736 24.5C3.27344 24.5 3.07897 24.4465 2.90394 24.3396C2.72892 24.2326 2.59278 24.0917 2.49555 23.9167C2.39831 23.7417 2.34483 23.5521 2.33511 23.3479C2.32538 23.1438 2.37886 22.9444 2.49555 22.75L13.2888 4.08333C13.4055 3.88889 13.5562 3.74306 13.741 3.64583C13.9257 3.54861 14.1153 3.5 14.3098 3.5C14.5043 3.5 14.6939 3.54861 14.8787 3.64583C15.0634 3.74306 15.2141 3.88889 15.3308 4.08333L26.1241 22.75C26.2408 22.9444 26.2943 23.1438 26.2845 23.3479C26.2748 23.5521 26.2213 23.7417 26.1241 23.9167C26.0269 24.0917 25.8907 24.2326 25.7157 24.3396C25.5407 24.4465 25.3462 24.5 25.1323 24.5H3.48736ZM14.3098 21C14.6404 21 14.9175 20.8882 15.1412 20.6646C15.3648 20.441 15.4767 20.1639 15.4767 19.8333C15.4767 19.5028 15.3648 19.2257 15.1412 19.0021C14.9175 18.7785 14.6404 18.6667 14.3098 18.6667C13.9792 18.6667 13.7021 18.7785 13.4784 19.0021C13.2548 19.2257 13.143 19.5028 13.143 19.8333C13.143 20.1639 13.2548 20.441 13.4784 20.6646C13.7021 20.8882 13.9792 21 14.3098 21ZM14.3098 17.5C14.6404 17.5 14.9175 17.3882 15.1412 17.1646C15.3648 16.941 15.4767 16.6639 15.4767 16.3333V12.8333C15.4767 12.5028 15.3648 12.2257 15.1412 12.0021C14.9175 11.7785 14.6404 11.6667 14.3098 11.6667C13.9792 11.6667 13.7021 11.7785 13.4784 12.0021C13.2548 12.2257 13.143 12.5028 13.143 12.8333V16.3333C13.143 16.6639 13.2548 16.941 13.4784 17.1646C13.7021 17.3882 13.9792 17.5 14.3098 17.5Z" fill="#FFB32F" />
                        </svg>

                        <TextHeader>
                            <strong>Você possui pedidos com mais de 24 horas em aberto no seu delivery.</strong>
                        </TextHeader>
                    </HeaderModal>
                    <BodyModal>
                        <TextBody>
                            Para que seus relatórios e o caixa sejam contabilizados corretamente, finalize esses pedidos.
                        </TextBody>
                    </BodyModal>
                    <FooterModal>
                        <span>
                            🔔 Lembre-se: pedidos em aberto são finalizados automaticamente após 10 dias.
                        </span>
                        <Button
                            customColor="#FFB32F"
                            style={{ width: 69 }}
                            onClick={closeModal}
                        >
                            Ok
                        </Button>
                    </FooterModal>
                </ContainerModal>
            </Overlay>
        )
    );
};
